export default __webpack_public_path__ + "media/images/front/about/point_3_img-47208004e9fac7580d7de86b45d74f71.jpg";